/**
 * Миниатюры вложений заготовки.
 *
 * Одна компонента на список, редактор и композер: вложение везде выглядит
 * одинаково, и по миниатюре видно, что уйдёт вместе с текстом. Видео —
 * кадром через <video preload="metadata">: отдельного превью у нас нет, а
 * первый кадр браузер вытаскивает сам.
 */

import type { QuickReplyAttachmentDto } from '../lib/api.js';
import { VideoIcon } from './icons.tsx';
import { cn } from '@/lib/utils';

interface QuickReplyThumbsProps {
  replyId: string;
  attachments: QuickReplyAttachmentDto[];
  size?: 'xs' | 'md';
  /** Крестик удаления. Только в редакторе. */
  onRemove?: (attachmentId: string) => void;
  disabled?: boolean;
}

export function QuickReplyThumbs({ replyId, attachments, size = 'md', onRemove, disabled }: QuickReplyThumbsProps) {
  const box = size === 'xs' ? 'size-10 rounded-md' : 'size-20 rounded-xl';

  return (
    <span className="flex flex-wrap gap-1.5">
      {attachments.map((a) => {
        const src = `/api/quick-replies/${replyId}/attachments/${a.id}`;
        return (
          <span key={a.id} className={cn('relative flex-none overflow-hidden bg-muted', box)}>
            {a.kind === 'video' ? (
              <>
                <video src={src} preload="metadata" muted className="size-full object-cover" />
                <VideoIcon className="absolute bottom-1 left-1 size-3.5 text-white drop-shadow" />
              </>
            ) : (
              <img src={src} alt={a.fileName ?? 'Фото'} loading="lazy" className="size-full object-cover" />
            )}
            {onRemove && (
              <button
                type="button"
                aria-label="Убрать вложение"
                disabled={disabled}
                onClick={(e) => {
                  e.stopPropagation();
                  onRemove(a.id);
                }}
                className="absolute right-0.5 top-0.5 grid size-5 place-items-center rounded-full bg-black/60 text-[11px] leading-none text-white transition-colors hover:bg-destructive disabled:opacity-50"
              >
                ×
              </button>
            )}
          </span>
        );
      })}
    </span>
  );
}
